"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedrainbowsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedrainbowsm` : '') + (description ? ` desc-brandedrainbowsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedrainbowsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedrainbowsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 14.3c0-1.54-1.1-2.82-2.56-3.09a4.69 4.69 0 0 0-8.31-.62 3.6 3.6 0 0 0-5.55 1.92C1.77 12.05 0 13.27 0 14.92c0 1.65 1.73 2.86 3.55 2.42a2.8 2.8 0 0 0 4.56.3 5 5 0 0 0 4.39 2.61 5.1 5.1 0 0 0 4.5-2.83c1.66-.06 3-1.44 3-3.13Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.07.13A15.81 15.81 0 0 0 2.7 12.42c.29-.02.6.01.9.09a3.6 3.6 0 0 1 1.75-2.18A13.92 13.92 0 0 1 20 2.14V.24c-.65-.06-1.3-.1-1.93-.1Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.07 2a13.92 13.92 0 0 0-12.72 8.33 3.6 3.6 0 0 1 2.3-.38A12.02 12.02 0 0 1 20 4.05v-1.9c-.64-.1-1.29-.14-1.93-.14Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.07 3.89A12 12 0 0 0 7.65 9.95c.54.1 1.05.3 1.5.63.36-.58.83-1.07 1.4-1.45A10.12 10.12 0 0 1 20 5.96V4.05c-.64-.1-1.28-.16-1.93-.16Z",
    fill: "#8AE6EB"
  }));
};
var _default = exports.default = brandedrainbowsm;